import { render, staticRenderFns } from "./SettingsInputText.vue?vue&type=template&id=312481f1&scoped=true&"
import script from "./SettingsInputText.vue?vue&type=script&lang=js&"
export * from "./SettingsInputText.vue?vue&type=script&lang=js&"
import style0 from "./SettingsInputText.vue?vue&type=style&index=0&id=312481f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312481f1",
  null
  
)

export default component.exports